import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const InvoiceInfoDialogTourConfig: AgTechTourConfig = {
    id: 'invoice-info-dialog-tour',
    name: 'Invoice Tour',
    steps: [
        {
            targetId: 'invoice-info-actions',
            title: 'Print and Download',
            description: 'Print the invoice or download it as a PDF.',
            position: 'bottom',
        },
        {
            targetId: 'invoice-info-summary',
            title: 'Invoice and Contact',
            description: 'The invoice date, its status and the contact being invoiced. Use the contact link to open their full details.',
            position: 'right',
        },
        {
            targetId: 'invoice-info-details',
            title: 'Invoice Contents',
            description: 'How many lots, charges and discounts, credits and payments the invoice has. Use the edit icon on any row to change them; the PDF refreshes with the new totals.',
            position: 'right',
        },
        {
            targetId: 'invoice-info-add-payment',
            skipIfMissing: true,
            title: 'Add a Payment',
            description: 'Record a payment against this invoice. This button disappears once the invoice is fully paid.',
            position: 'top',
        },
        {
            targetId: 'invoice-info-pdf',
            title: 'Invoice Preview',
            description: 'A preview of the invoice document exactly as it prints or downloads.',
            position: 'left',
        },
    ]
}
